module.exports = "/static/assets/a2287c8fce6d430522b550e223678c6a.png";